import React, { useState, useEffect } from "react";
import { buildApiUrl } from '../config';
import "./StockAvailability.css";

const StockAvailability = () => {
  const [stockData, setStockData] = useState([]);
  const [stockType, setStockType] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchStockData();
  }, [stockType, search]);

  const fetchStockData = async () => {
    try {
      const response = await fetch(
        buildApiUrl(`api/stock/availability?stockType=${stockType}&search=${search}`)
      );
      const data = await response.json();
      if (data.success) {
        setStockData(data.data);
      } else {
        console.error("Error fetching stock data:", data.error);
      }
    } catch (error) {
      console.error("Error fetching stock availability:", error);
    }
  };

  return (
    <div className="stock-availability-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
        <h1 style={{ margin: 0 }}>Availabile Stock</h1>
        <button
          onClick={() => {
            try {
              if (!stockData || stockData.length === 0) {
                alert('No data to export');
                return;
              }
              const headers = ['Category','Brand','Oil Type / Filter No','Quantity','Supplier','Last Purchase Date'];
              const rows = stockData.map((item) => [
                item.Category ?? '-',
                item.Brand ?? '-',
                item.OilType_FilterNo ?? '-',
                item.Quantity !== undefined ? String(Math.abs(item.Quantity)) + (item.Category === 'Oil' ? ' Litres' : '') : '-',
                item.Supplier ?? '-',
                item.LastPurchaseDate ? new Date(item.LastPurchaseDate).toLocaleDateString('en-GB') : '-'
              ]);
              const csv = [headers, ...rows]
                .map(row => row.map(cell => {
                  const val = cell === null || cell === undefined ? '' : String(cell);
                  const escaped = val.replace(/"/g, '""');
                  return /[",\n]/.test(escaped) ? `"${escaped}"` : escaped;
                }).join(',')).join('\n');
              const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Available_Stock_${new Date().toISOString().split('T')[0]}.csv`;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            } catch (e) {
              console.error('Export failed', e);
              alert('Failed to export CSV');
            }
          }}
          style={{
            background: 'none',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '18px',
            color: '#217346',
            padding: '6px 10px'
          }}
          title="Export current table to CSV"
        >
          📊
        </button>
      </div>

      {/* 🔹 Stock Table */}
      <table className="stock-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Brand</th>
            <th>Oil Type / Filter No</th>
            <th>Quantity</th>
            <th>Supplier</th>
            <th>Last Purchase Date</th>
          </tr>
        </thead>
        <tbody>
          {stockData.length > 0 ? (
            stockData.map((item, index) => (
              <tr key={index} className={item.Quantity < (item.Category === "Oil" ? 10 : 5) ? "low-stock" : ""}>
                <td>{item.Category}</td>
                <td>{item.Brand}</td>
                <td>{item.OilType_FilterNo}</td>
                <td>{Math.abs(item.Quantity)} {item.Category === "Oil" ? "Litres" : ""}</td>

                <td>{item.Supplier || "-"}</td>
                <td>{item.LastPurchaseDate ? new Date(item.LastPurchaseDate).toLocaleDateString("en-GB") : "-"}</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No stock available.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StockAvailability;
